module.exports = __webpack_public_path__ + "static/media/A18040103_10003_0.c8249514.jpg";